import { riskScore, riskBand, RISK_BAND_LABEL, type RiskRating } from "@/lib/templateContent";

export function RiskChip({ rating, showLabel = false }: { rating: RiskRating; showLabel?: boolean }) {
  const score = riskScore(rating);
  const band = riskBand(score);
  return (
    <span className="inline-flex items-center gap-1.5">
      <span className={`risk-chip risk-${band}`} title={`Likelihood ${rating.likelihood} × Severity ${rating.severity}`}>
        {score}
      </span>
      {showLabel && <span className="text-[0.62rem] font-medium uppercase tracking-wider text-muted">{RISK_BAND_LABEL[band]}</span>}
    </span>
  );
}
